export default __webpack_public_path__ + "./images/tag.e7cbd401.svg";